import { Immobile, OrarioPrenotazione, Profilo, ServizioAcquistato } from './index';

export class Messaggio {

	id: number;
	dataCreazione: Date;
	oggetto: string;
	messaggio: string;
	mittente: Profilo;
	destinatario: Profilo;
	immobile: Immobile;
	servizio: ServizioAcquistato;
	lettoDalDestinatario: boolean;
	lettoDalAmministratore: boolean;
	idMittente: number;
	idDestinatario: number;
	listOrarioPrenotazione: OrarioPrenotazione[];
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/messaggio.ts